import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams, useNavigate } from 'react-router-dom';
import './TIJSidebar.css';

// Import all your subcomponents
import Dibal500 from './Dibal500';
import Dibal900 from './Dibal900';
import Dibalpcscale from './Dibalpcscale';
import Dibalwind from './Dibalwind';
import Rongta from './Rongta';
import AIScale from './AIScale';

const RetailWeighingLayout = ({ mode }) => {
  const { type, subType } = useParams();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(type || mode || 'type1');
  const [activeSubCategory, setActiveSubCategory] = useState(subType || null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState({
    type1: false, // ZH category
    type2: false,
    type3: false  // ZX category
  });

  // Update URL when active category/subcategory changes
  useEffect(() => {
    if (activeSubCategory) {
      navigate(`/retail-scales/${activeCategory}/${activeSubCategory}`);
    } else {
      navigate(`/retail-scales/${activeCategory}`);
    }
  }, [activeCategory, activeSubCategory, navigate]);

  // Handle category switching
  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    setActiveSubCategory(null);
    setIsSidebarOpen(false);
    
    // Toggle category expansion
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  // Handle subcategory selection
  const handleSubCategoryChange = (subCategory) => {
    setActiveSubCategory(subCategory);
    setIsSidebarOpen(false);
  };

  // Toggle category expansion
  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  // Render the active component
  const renderActiveComponent = () => {
    if (activeCategory === 'type1' && activeSubCategory) {
      switch (activeSubCategory) {
        case 'sub1': return <Dibal500 />;
        case 'sub2': return <Dibal900 />;
        case 'sub3': return <Dibalwind /> ;
        case 'sub4': return <Dibalpcscale />;
        default: return <Dibal500 />;
      }
    } else if (activeCategory === 'type2') {
      return <Rongta />;
    } else if(activeCategory === 'type3'){
      return <AIScale />;
    }
    // Default view when no subcategory is selected for type1
    return <Dibal500/>;
  };

  return (
    <div className="page-container">
      <div className="content-wrap">
        {/* Mobile Navigation (Horizontal) - Simplified for mobile */}
        <div className="mobile-nav">
          <button
            className={`nav-link ${activeCategory === 'type1' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('type1')}
          >
            Dibal Scales
          </button>
          <button
            className={`nav-link ${activeCategory === 'type2' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('type2')}
          >
            Rongta Scales
          </button>

          <button
            className={`nav-link ${activeCategory === 'type3' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('type3')}
          >
            AI Scales
          </button>
        </div>

        {/* Hamburger Menu Toggle Button */}
        <button
          className="sidebar-toggle"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          ☰
        </button>

        {/* Sidebar */}
        <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <div className="mb-3 px-3 mt-3" style={{fontSize:"18px", fontWeight:"bold", textDecoration:"underline"}}>
            Weighing Scales
          </div>
          
          <nav className="nav flex-column">
            {/* ZH Category with subcategories */}
            <div className="sidebar-category">
              <button
                className={`nav-link category-title ${activeCategory === 'type1' ? 'active' : ''}`}
                onClick={() => handleCategoryChange('type1')}
              >
                Dibal Scales
                <span className="toggle-icon">
                  {expandedCategories.type1 ? '−' : '+'}
                </span>
              </button>
              
              {expandedCategories.type1 && (
                <div className="subcategories">
                  <button
                    className={`nav-link subcategory ${activeSubCategory === 'sub1' ? 'active' : ''}`}
                    onClick={() => handleSubCategoryChange('sub1')}
                    style={{marginLeft:"13px"}}
                  >
                    Dibal 500 series
                  </button>
                  <button
                    className={`nav-link subcategory ${activeSubCategory === 'sub2' ? 'active' : ''}`}
                    onClick={() => handleSubCategoryChange('sub2')}
                    style={{marginLeft:"13px"}}
                  >
                    Dibal 900 series
                  </button>
                  <button
                    className={`nav-link subcategory ${activeSubCategory === 'sub3' ? 'active' : ''}`}
                    onClick={() => handleSubCategoryChange('sub3')}
                    style={{marginLeft:"13px"}}
                  >
                    Wind series
                  </button>
                  <button
                    className={`nav-link subcategory ${activeSubCategory === 'sub4' ? 'active' : ''}`}
                    onClick={() => handleSubCategoryChange('sub4')}
                    style={{marginLeft:"13px"}}
                  >
                    PC Scales
                  </button>
                </div>
              )}
            </div>

            {/* ZX Category (no subcategories) */}
            <button
              className={`nav-link ${activeCategory === 'type2' ? 'active' : ''}`}
              onClick={() => handleCategoryChange('type2')}
            >
              Rongta Scales
            </button>

            <button
              className={`nav-link ${activeCategory === 'type3' ? 'active' : ''}`}
              onClick={() => handleCategoryChange('type3')}
            >
              AI Scales
            </button>
          </nav>
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
};

export default RetailWeighingLayout;